import React, { useEffect, useState } from 'react';
import { Text, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import { Button } from 'toolkit/chakra/button';

type Profile = {
  email: string;
};

const Settings = () => {
  const router = useRouter();
  const [profile, setProfile] = useState<Profile | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (!token) return;

    const fetchProfile = async () => {
      try {
        const res = await fetch('/api/auth/validate', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
  
        if (!res.ok) {
          // Token invalid / expired
          if (res.status === 401) {
            console.warn('Unauthorized');
            setProfile(null);
            return;
          }
          throw new Error(`Request failed: ${res.status}`);
        }
  
        const data = await res.json();

        if (data.valid) {
          setProfile(data);
        }
      } catch (err) {
        console.error('Fetch profile error:', err);
        setProfile(null);
      }
    };
  
    fetchProfile();
  }, []);

  // Not logged in → show Login
  if (!profile) {
    return (
      <Button size="sm" onClick={() => router.push('/login')}>
        Log in
      </Button>
    );
  }

  // Logged in → show email + logout
  return (
    <Flex align="center" gap={3}>
      <Text fontSize="sm" fontWeight="medium">
        {profile.email}
      </Text>

      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          localStorage.removeItem('auth_token');
          document.cookie = 'auth_token=; Max-Age=0; path=/';
          window.location.href = '/login';
        }}
      >
        Logout
      </Button>
    </Flex>
  );
};

export default React.memo(Settings);
